import type {
  ConnectorConnection,
  ConnectorProvider,
} from '@saaga/shared/interfaces/connector.interface'
import {
  useGetConnectorConnectionsQuery,
  useGetConnectorProvidersQuery,
} from '@saaga/shared/store/connector-endpoints.store'

import type { UseConnectorHandlersReturn } from './use-connector-handlers.hook'
import { useConnectorHandlers } from './use-connector-handlers.hook'

export interface UseConnectorsSettingsReturn extends UseConnectorHandlersReturn {
  providerList: ConnectorProvider[]
  connectionList: ConnectorConnection[]
  isLoading: boolean
}

export const useConnectorsSettings = (): UseConnectorsSettingsReturn => {
  const { data: providerList = [], isLoading: isProvidersLoading } = useGetConnectorProvidersQuery()
  const { data: connectionsData, isLoading: isConnectionsLoading } =
    useGetConnectorConnectionsQuery()
  const connectionList = connectionsData?.itemList ?? []

  const handlers = useConnectorHandlers(connectionList)

  return {
    providerList,
    connectionList,
    isLoading: isProvidersLoading || isConnectionsLoading,
    ...handlers,
  }
}
